import FormPageFake, {
  THEMES as FAKE_THEMES,
} from '@/components/fakes/formPagesFake';

function FormMiMovistarFake() {
  return (
    <FormPageFake
      formTemplateFakes={[
        {
          fakeLength: 6,
        },
        {
          fakeLength: 1,
        },
        {
          theme: FAKE_THEMES.boxRadioButtonList,
          fakeLength: 2,
        },
        {
          fakeLength: 1,
        },
      ]}
    />
  );
}
export default FormMiMovistarFake;
